import dayjs from "dayjs";

function countByDate(data) {
  const counts = {};
  console.log(data);
  data.forEach((item) => {
    const date = dayjs(item.fortuneDate).format("YY-MM-DD");
    counts[date] = (counts[date] || 0) + 1;
  });

  // 날짜순 정렬
  const sorted = Object.entries(counts).sort((a, b) =>
    a[0].localeCompare(b[0])
  );

  return {
    labels: sorted.map(([date]) => date),
    data: sorted.map(([_, count]) => count),
  };
}

function countByType(data) {
  const counts = {};

  data.forEach((item) => {
    const type = item.type || "unknown";
    counts[type] = (counts[type] || 0) + 1;
  });

  const labels = Object.keys(counts);
  const values = labels.map((label) => counts[label]);

  return { labels, values };
}

function countByLanguage(data) {
  const counts = {};

  data.forEach((item) => {
    const lang = item.userLanguage || "unknown";
    counts[lang] = (counts[lang] || 0) + 1;
  });

  const labels = Object.keys(counts);
  const values = labels.map((lang) => counts[lang]);

  return { labels, values };
}
function countByGender(data) {
  const counts = { man: 0, woman: 0 };

  data.forEach((item) => {
    const gender = item.gender === "woman" ? "woman" : "man";
    counts[gender] += 1;
  });

  return {
    labels: ["남자", "여자"],
    values: [counts.man, counts.woman],
  };
}
export { countByDate, countByType, countByLanguage, countByGender };
